import { useCallback } from 'react';

export const useMeasurementTools = (map) => {
  // Общая логика для всех инструментов измерения
  // Например, форматирование вывода, создание временных слоев для отображения

  const getFormattedArea = useCallback((feature) => {}, []);

  return { getFormattedArea };
};